import { Image } from '@chakra-ui/react'
import { Backdrop } from 'components'
import { useTheme } from 'utils'

export default function LogoLoader() {
  const { theme } = useTheme()

  return (
    <Backdrop justify="center" align="center" flex={1} gap={14}>
      <Image
        src={
          theme === 'light'
            ? '/common/momentify-icon-dark.svg'
            : '/common/momentify-icon-light.svg'
        }
        alt="momentify logo"
        height="200px"
      />
    </Backdrop>
  )
}
